import React, { useState } from "react";
// import axios from 'axios';
import { analytics, db, auth, app } from "../firebase";
import { collection, getDocs, addDoc } from "firebase/firestore";

import { Button } from "react-bootstrap";
import './UserForm.css';

import Alert from 'react-bootstrap/Alert';



const UserForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        service: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formDataCollection = collection(db, "formData");
            await addDoc(formDataCollection, formData);
            const alertBox = document.createElement("div");
            alertBox.textContent = "Thank you for your submission! We will contact you soon.";
            alertBox.style.top = "20px";
            alertBox.style.right = "40px";
            alertBox.style.bottom = "unset";
            alertBox.style.position = "fixed";
            alertBox.style.backgroundColor = "#28a745";
            alertBox.style.color = "#fff";
            alertBox.style.padding = "15px 20px";
            alertBox.style.borderRadius = "5px";
            alertBox.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)";
            alertBox.style.fontSize = "16px";
            alertBox.style.zIndex = "1000";
            document.body.appendChild(alertBox);

            setTimeout(() => {
                alertBox.style.transition = "opacity 1.5s";
                alertBox.style.opacity = "0";
                setTimeout(() => document.body.removeChild(alertBox), 1000);
            }, 3000);
            setFormData({
                name: "",
                phone: "",
                email: "",
                service: "",
            });
        } catch (error) {
            
            console.error("Error submitting form: ", error);
            alert("Failed to submit the form. Please try again.");
        }
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     try {
    //       await axios.post('http://localhost:5000/send-email', formData);
    //       alert('Email sent successfully!');
    //     } catch (error) {
    //       console.error(error);
    //       alert('Error sending email');
    //     }
    //   };

    return (
        <div style={{ display: "flex", justifyContent: "top", alignItems: "top", height: "50rem" }}>
            <form onSubmit={handleSubmit} style={{ width: "300px", textAlign: "center" }}>
                <h4 style={{ width: "50%", textAlign: "center", padding: "8px", margin: "auto", borderRadius: "5px" }}>Request a Fire Alarm Service</h4>
                <div style={{ marginBottom: "10px" }}>
                    <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        style={{ width: "75%", padding: "8px", marginBottom: "10px", borderRadius: "5px" }}
                    />
                </div>
                <div style={{ marginBottom: "10px" }}>
                    <input
                        type="text"
                        name="phone"
                        placeholder="Phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        style={{ width: "75%", padding: "8px", marginBottom: "10px", borderRadius: "5px" }}
                    />
                </div>
                <div style={{ marginBottom: "10px" }}>
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        style={{ width: "75%", padding: "8px", marginBottom: "10px", borderRadius: "5px" }}
                    />
                </div>
                <div style={{ marginBottom: "10px" }}>
                    <select
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                        style={{
                            width: "60%",
                            padding: "8px",
                            marginBottom: "10px",
                            textAlign: "left",
                            textAlignLast: "left", // For modern browsers
                            alignItems: "left",
                            justifyContent: "left",
                            borderRadius: "5px"
                        }}
                    >
                        <option value="" disabled>Select Service</option>
                        <option value="Inspections">Inspections</option>
                        <option value="Monitoring">Monitoring</option>
                        <option value="Service">Service</option>
                        <option value="New Install">New Install</option>
                        <option value="Design">Design</option>
                        <option value="Renovation">Renovation</option>
                        <option value="Consult">Consult</option>
                    </select>
                </div>
                <Button type="submit" variant="outline-light">
                    Submit
                </Button>
            </form>
        </div>
    );
};

export default UserForm;